import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";

export default function ProfileAvatar({ photoUrl, name = "", size = "lg", className = "" }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [photoUrl]);

  const sizes = {
    sm: "w-8 h-8",
    header: "w-10 h-10",
    chat: "w-10 h-10",
    card: "w-14 h-14",
    result: "w-[108px] h-[108px]",
    md: "w-16 h-16",
    lg: "w-24 h-24",
  };
  const iconSizes = { sm: 15, header: 18, chat: 18, card: 22, result: 32, md: 25, lg: 34 };
  const sizeClass = sizes[size] || sizes.lg;

  if (photoUrl && !failed) {
    return (
      <img
        src={photoUrl}
        alt={name ? `Profilbillede af ${name}` : "Profilbillede"}
        width={size === "result" ? 108 : undefined}
        height={size === "result" ? 108 : undefined}
        decoding="async"
        className={`${sizeClass} rounded-full object-cover border border-brand-line ${className}`}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div className={`${sizeClass} rounded-full bg-brand-soft border border-brand-line flex items-center justify-center text-brand-muted ${className}`} aria-label="Intet profilbillede">
      <UserRound size={iconSizes[size] || iconSizes.lg}/>
    </div>
  );
}

